import { ContainedIcon } from '@frontend/icons';
import { theme } from '@frontend/theme';

export const Transferred = ({ as = 'span' }: { as?: React.ElementType }) => {
  return (
    <ContainedIcon
      as={as}
      css={{
        padding: 1,
        borderRadius: theme.borderRadius.small,
      }}
      iconName='call-source'
      color={theme.colorsV2.indigo50()}
    />
  );
};
